import React from 'react';
import { partition } from 'lodash';
import TestConnectionVariable from './TestConnectionVariable/TestConnectionVariable';
import ConnectionModel from '@mm/state/model/ConnectionModel';
import {
  ExtendedVariablesModel,
  SetUrlVariablesLocal,
  SetVariablesLocal,
  UrlVariablesLocal,
} from '../TestConnectionModal';
import './SendRequestPane.pcss';

type Props = {
  variablesLocal: ExtendedVariablesModel[];
  connection: ConnectionModel;
  url: string;
  setVariablesLocal: SetVariablesLocal;
  urlVariablesLocal: UrlVariablesLocal[];
  setUrlVariablesLocal: SetUrlVariablesLocal;
};

const SendRequestPane = (props: Props) => {
  const {
    variablesLocal,
    connection,
    url,
    setVariablesLocal,
    urlVariablesLocal,
    setUrlVariablesLocal,
  } = props;

  const [headerVariables, bodyVariables] = partition(variablesLocal, 'header');

  return (
    <div className="test-connection-modal__step">
      <div className="test-connection-modal__url-wrapper">
        <div className="test-connection-modal__url-label field">URL</div>
        <div className="test-connection-modal__url-value">{url}</div>
      </div>

      {!!urlVariablesLocal.length && (
        <div className="test-connection-modal__variables-section-wrapper">
          <h3>Url Params</h3>

          <div className="test-connection-modal__variables-wrapper">
            {urlVariablesLocal.map((variable, index) => (
              <TestConnectionVariable
                key={variable.name}
                index={index}
                variablesModal={urlVariablesLocal}
                updateVariables={setUrlVariablesLocal}
                connection={connection}
                name={variable.name}
                value={variable.value}
                isStatic={false}
                staticValue={variable.value}
              />
            ))}
          </div>
        </div>
      )}

      {headerVariables.length && (
        <div className="test-connection-modal__variables-section-wrapper">
          <h3>Request headers</h3>

          <div className="test-connection-modal__variables-wrapper">
            {headerVariables.map(variable => (
              <>
                <span className="test-connection-modal__variable-header">
                  <b>{variable.name}</b>
                </span>
                <span className="test-connection-modal__variable-header">
                  {variable.value}
                </span>
              </>
            ))}
          </div>
        </div>
      )}

      <div className="test-connection-modal__variables-section-wrapper">
        <h3>Request Body</h3>

        <div className="test-connection-modal__variables-wrapper">
          {bodyVariables &&
            bodyVariables.map((variable, index) => (
              <TestConnectionVariable
                key={variable.id}
                index={index}
                variablesModal={bodyVariables}
                updateVariables={setVariablesLocal}
                connection={connection}
                name={variable.sentAs}
                value={variable.name}
                isStatic={variable.static}
                staticValue={variable.value}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default SendRequestPane;
